'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createIconComponent = require('./utils/createIconComponent');

var _createIconComponent2 = _interopRequireDefault(_createIconComponent);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconDrawerOpen = (0, _createIconComponent2.default)({ fillContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M23.876 11.263l-3.07-5.5a1.956 1.956 0 0 0-1.7-1.009H4.9a1.955 1.955 0 0 0-1.7 1.005L.13 11.263a1.382 1.382 0 0 0-.13.487v6a1.5 1.5 0 0 0 1.5 1.5h21a1.5 1.5 0 0 0 1.5-1.5v-6a1.218 1.218 0 0 0-.124-.487zM4.83 6.879a.248.248 0 0 1 .218-.129l13.865-.016a.248.248 0 0 1 .218.128l2.241 4.016a.25.25 0 0 1-.218.372H17.5a1.491 1.491 0 0 0-1.061.439A1.51 1.51 0 0 0 16 12.75a1.5 1.5 0 0 1-1.5 1.5h-5a1.5 1.5 0 0 1-1.5-1.5 1.5 1.5 0 0 0-1.5-1.5H2.844a.251.251 0 0 1-.219-.371z' })
  ), lightContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M1.5 19C.673 19 0 18.327 0 17.5v-6c0-.015.002-.034.005-.051.004-.032.011-.058.016-.077.006-.021.013-.046.025-.075a.29.29 0 0 1 .022-.05l3.21-5.499A1.508 1.508 0 0 1 4.573 5h14.854c.533.002 1.03.289 1.296.75l3.209 5.498a.443.443 0 0 1 .047.124.524.524 0 0 1 .021.128v6c0 .827-.673 1.5-1.5 1.5h-21zM1 17.5a.5.5 0 0 0 .5.5h21a.5.5 0 0 0 .5-.5V12h-6v.5a2.512 2.512 0 0 1-2.499 2.5H9.5A2.512 2.512 0 0 1 7 12.501V12H1v5.5zM7.5 11a.5.5 0 0 1 .5.5v1A1.51 1.51 0 0 0 9.501 14H14.5a1.509 1.509 0 0 0 1.5-1.501V11.5a.5.5 0 0 1 .5-.5h6.129l-2.772-4.748A.503.503 0 0 0 19.425 6H4.575a.502.502 0 0 0-.431.25L1.371 11H7.5z' })
  ), regularContent: _react2.default.createElement(
    'g',
    null,
    _react2.default.createElement('path', { d: 'M2.25 16.5A2.252 2.252 0 0 1 0 14.25v-4.5A2.252 2.252 0 0 1 2.25 7.5h4.582a.75.75 0 0 1 .651.378 5.193 5.193 0 0 0 4.507 2.621 5.218 5.218 0 0 0 4.526-2.621.755.755 0 0 1 .652-.378h4.582A2.252 2.252 0 0 1 24 9.75v4.5a2.252 2.252 0 0 1-2.25 2.25H2.25zm0-7.5a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75h19.5a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-.75-.75h-4.163a6.665 6.665 0 0 1-5.598 2.999A6.691 6.691 0 0 1 6.414 9H2.25z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconDrawerOpen.displayName = 'IconDrawerOpen';
exports.default = IconDrawerOpen;